class AccountValueHistory {
    items;
    constructor(data) {
        this.items = data.items;
    }
}
export default AccountValueHistory;
